import { render, staticRenderFns } from "./CustomLoginContainer.vue?vue&type=template&id=5b39385e&scoped=true"
import script from "./CustomLoginContainer.vue?vue&type=script&lang=js"
export * from "./CustomLoginContainer.vue?vue&type=script&lang=js"
import style0 from "./CustomLoginContainer.vue?vue&type=style&index=0&id=5b39385e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39385e",
  null
  
)

export default component.exports